import Vue from 'vue'
import Vuex from 'vuex'
import user from './store/modules/user'
import club from './store/modules/club'
import team from './store/modules/team'
import travel from './store/modules/travel'
import hotel from './store/modules/hotel'
import person from './store/modules/person'
import finance from './store/modules/finance'

import { Api } from '@/core/api.js'

import router from './router'
import i18n from '@/i18n'
const api = new Api()

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    usermenu_is_visible: false,
    menu_is_visible: false,
    language: '',
    languages: [],
    app_url: 'http://localhost:8080',
    table_relatioship: false,
    countries: [],
    player_positions: [],
    staff_level: [],
    alergy: [],
    campus: false,
    how_meet: [],
    contact_type: {},
    transport_mode: [],
    category_type: {},
    selected_team: false,
    current_event: false,
    active_events: [],
    hotel_services: [],
    campus_type: {},
    campus_type_pga: {},
    shirt_size: {},
    diet: {},
    reject_documents: {},
    sign_document_error: false,
    token:
      typeof localStorage.token !== 'undefined' ? localStorage.token : false,
    document_type: false
  },
  modules: {
    user,
    club,
    team,
    travel,
    hotel,
    person,
    finance
  },
  strict: debug,
  mutations: {
    setSelectedTeam (state, value) {
      state.selected_team = value
    },

    setMenuVisible (state, value) {
      state.menu_is_visible = value
    },

    setOverlayVisible (state, value) {
      state.overlay_is_visible = value
    },

    setUserMenuVisible (state, value) {
      state.usermenu_is_visible = value
    },

    setLanguage (state, value) {
      state.language = value
    },

    signDocumentError (state, value) {
      state.sign_document_error = value
      Vue.set(state, 'sign_document_error', value)
    },

    setTables (state, tables) {
      state.table_relatioship = true

      if (typeof tables['country'] !== 'undefined') {
        state.countries = tables['country']
      }

      if (typeof tables['player_position'] !== 'undefined') {
        state.player_positions = tables['player_position']
      }

      if (typeof tables['language'] !== 'undefined') {
        state.languages = tables['language']
      }

      if (typeof tables['staff_level'] !== 'undefined') {
        state.staff_level = tables['staff_level']
      }

      if (typeof tables['alergy'] !== 'undefined') {
        state.alergy = tables['alergy']
      }

      if (typeof tables['how_meet'] !== 'undefined') {
        state.how_meet = tables['how_meet']
      }

      if (typeof tables['contact_type'] !== 'undefined') {
        state.contact_type = tables['contact_type']
      }

      if (typeof tables['category_type'] !== 'undefined') {
        state.category_type = tables['category_type']
      }

      if (typeof tables['service_type'] !== 'undefined') {
        state.service_type = tables['service_type']
      }

      // nike
      if (typeof tables['campus_type'] !== 'undefined') {
        state.campus_type = tables['campus_type']
      }

      // pga
      if (typeof tables['campus_type'] !== 'undefined') {
        state.campus_type_pga = tables['campus_type']
      }

      if (typeof tables['shirt_size'] !== 'undefined') {
        state.shirt_size = tables['shirt_size']
      }

      if (typeof tables['join_campus'] !== 'undefined') {
        state.join_campus = tables['join_campus']
      }

      if (typeof tables['diet'] !== 'undefined') {
        state.diet = tables['diet']
      }

      if (typeof tables['contact_type'] !== 'undefined') {
        state.contact_type = tables['contact_type']
      }

      if (typeof tables['transport_mode'] !== 'undefined') {
        state.transport_mode = tables['transport_mode']
      }

      if (typeof tables['hotel_service'] !== 'undefined') {
        state.hotel_services = tables['hotel_service']
      }

      if (typeof tables['reject_documents'] !== 'undefined') {
        state.reject_documents = tables['reject_documents']
      }
    },

    setCampus (state, value) {
      state.campus = value
    },

    setCurrentEvent (state, event) {
      state.current_event = event
    },

    setActiveEvents (state, events) {
      state.active_events = events
    },

    setToken (state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },

    setTokenWithoutStorage (state, token) {
      state.token = token
    },

    setDocumentType (state, document) {
      state.document_type = document
    }
  },
  actions: {
    loadTablesRelationship: ({ commit }) => {
      return api.get('table').then(function (data) {
        if (data.status) {
          return commit('setTables', data.data)
        }
      })
    },

    getCampusInfo: ({ commit }, params) => {
      return api
        .get('inscripcions/' + params.event_id + '/1')
        .then(function (response) {
          return commit('setTables', response.data)
        })
    },

    loadUser ({ commit, rootState, dispatch, state }) {
      return api.get('init').then(function (data) {
        if (data.status) {
          dispatch('loadTablesRelationship')
          commit('user/setAuthenticate', data.data)
          return dispatch('loadEventByID', data.data.user.event_id).then(
            function () {}
          )
        }
      })
    },

    loadEventByName ({ commit, dispatch, state }, eventName) {
      var path = 'event/name/' + eventName
      return api.get(path).then(function (response) {
        if (response.status) {
          var data = response.data
          data.main_actions = data.main_actions === '1'
          data.credentials = data.credentials === '1'
          data.transfers = data.transfers === '1'
          data.insurance = data.insurance === '1'
          data.visible = true
          data.is_campus = parseInt(data.is_campus)

          if (state.current_event && state.current_event.id !== data.id) {
            router.push({ name: 'login' })
          }
          return commit('setCurrentEvent', data)
        }
      })
    },

    loadEventByID ({ commit, dispatch, state }, event) {
      var path = 'event/' + event
      return api.get(path).then(function (response) {
        if (response.status) {
          var data = response.data
          data.main_actions = data.main_actions === '1'
          data.credentials = data.credentials === '1'
          data.transfers = data.transfers === '1'
          data.insurance = data.insurance === '1'
          data.visible = true
          data.is_campus = parseInt(data.is_campus)
          if (state.current_event && state.current_event.id !== data.id) {
            router.push({ name: 'login' })
          }
          return commit('setCurrentEvent', data)
        }
      })
    },

    upload (context, data) {
      var document = { ...data }
      let form = new FormData()

      Object.entries(document.files).forEach(([key, value]) => {
        form.append(key, document.files[key])
      })

      form.append('id', document.id)

      var path = 'campus/upload/' + data.type

      return api.import(path, form).then(function (response) {
        return response
      })
    },

    logout ({ commit }) {
      commit('user/logoutUser')
    },

    setPage ({ commit, dispatch, state }, page) {
      return new Promise((resolve, reject) => {
        if (typeof page.params.event !== 'undefined') {
          var event = page.params.event
          dispatch('loadEventByName', event).then(function () {
            resolve()
          })
        } else {
          resolve()
        }
      })
    },

    loadInfo ({ commit, dispatch, state }) {
      return api.get('info').then(function (response) {
        if (response.status) {
          var data = response.data

          return commit('setActiveEvents', data)
        }
        return true
      })
    },

    loadMICUser ({ commit, dispatch, state }, params) {
      return api
        .get(
          'initmicpreview/' +
            params.token +
            '/' +
            params.event +
            '/' +
            params.entity +
            '/' +
            params.entityid
        )
        .then(function (response) {
          if (response.status) {
            // localStorage.setItem("token", response.data.token);
            commit('setToken', response.data.token)
            dispatch('loadTablesRelationship')
            commit('user/setAuthenticate', response.data)
            state.user.user.language = 'ca'
            return dispatch('loadEventByID', response.data.user.event_id).then(
              function () {}
            )
          }
        })
    },

    loadSignTokenUser ({ commit, dispatch, state }, params) {
      return api
        .get('initsigntoken/' + params.event + '/' + params.token)
        .then(function (response) {
          //   localStorage.setItem("token", response.data.token);
          commit('setTokenWithoutStorage', response.data.token)
          if (response.status) {
            dispatch('loadTablesRelationship')
            commit('user/setAuthenticate', response.data)
            commit('setDocumentType', response.data2.document)
            //   state.user.user.language = response.data.language;
            i18n.loadLanguageAsync(
              response.data.user.language ? response.data.user.language : 'ca'
            )
            return dispatch('loadEventByID', response.data.user.event_id).then(
              function () {}
            )
          } else {
            commit('signDocumentError', response.error)
            // dispatch("loadTablesRelationship");
            commit('user/setAuthenticate', response.data)
            commit('setDocumentType', response.data2.document)
            i18n.loadLanguageAsync(
              response.data.language ? response.data.language : 'ca'
            )
            return true
            //   state.user.user.language = response.data.language;
            // return dispatch("loadEventByID", response.data.user.event_id).then(
            //   function () {}
            // );
          }
        })
    }
  },

  getters: {
    getSelectedTeam: (state, getter, rootState) => {
      return state.selected_team
    },

    getLanguages: (state, getter, rootState) => {
      return state.languages
    },

    getCountries: (state, getters, rootState) => {
      return state.countries
    },

    getPlayerPositions: (state, getters, rootState) => {
      return state.player_positions
    },

    getStaffLevel: (state, getter, rootState) => {
      return state.staff_level
    },

    getAlergy: (state, getter, rootState) => {
      return state.alergy
    },

    getCampus: (state, getter, rootState) => {
      return state.campus
    },

    getHowMeet: (state, getter, rootState) => {
      return state.how_meet
    },

    getCategoryType: (state, getter, rootState) => {
      return state.category_type
    },

    getTransportMode: (state, getter, rootState) => () => {
      return state.transport_mode
    },

    getLanguage: (state, getter, rootState) => {
      return state.language
    },

    getCampusType: (state, getter, rootState) => {
      return state.campus_type
    },

    getCampusTypePGA: (state, getter, rootState) => {
      return state.campus_type_pga
    },

    getShirtSizes: (state, getter, rootState) => {
      return state.shirt_size
    },

    getDiets: (state, getter, rootState) => {
      return state.diet
    },

    getContactType: (state, getter, rootState) => {
      return state.contact_type
    },

    getCurrentEvent: (state, getters, rootState) => () => {
      return state.current_event
    },

    getActiveEvents: (state, getters, rootState) => () => {
      return state.active_events
    },

    getJoinCampus: (state, getter, rootState) => {
      return state.join_campus
    },

    getHotelServices: (state, getters, rootState) => () => {
      return state.hotel_services
    },

    getRejectDocuments: (state, getters, rootState) => (id) => {
      return typeof id !== 'undefined'
        ? state.reject_documents[id]
        : state.reject_documents
    },
    getSignDocumentError: (state, getters, rootState) => {
      return state.sign_document_error
    },
    getToken: (state, getters, rootState) => {
      return state.token
    },
    getDocumentType: (state, getters, rootState) => {
      return state.document_type
    }
  }
})
